import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/affordable-college-storage-solutions.jpg'),
    alt: 'affordable college storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'affordable college storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>College</span><span>Storage Solutions</span>',
  description:
    "Finding affordable storage shouldn't be a hassle. At ShipAndStorage, we offer budget-friendly college storage solutions with free pickup, secure storage, and flexible return options.",
  image: {
    url: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/hero-image.jpg',
    alt: 'Affordable College Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up Now' }
}

export const ourProcessSectionContent = {
  title: 'Affordable College Storage Services for Students',
  description: 'We provide a seamless and secure college storage process in three simple steps:',

  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Your Storage' },

  image: {
    url: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/affordable-college-storage-services-for-students.png',
    alt: 'Affordable College Storage Services for Students'
  },

  articles: [
    {
      id: 1,
      title: 'Book Your Storage Online',
      description: 'Select your storage plan, schedule a pickup, and receive instant confirmation.',
      image: {
        src: '/images/v2/pages/common/easy-booking-tracking.png',
        alt: 'Book Your Storage Online'
      }
    },
    {
      id: 2,
      title: 'Pickup & Safe Transport',
      description: 'Our team collects your belongings and transports them to our secure, climate-controlled facility.',
      image: {
        src: '/images/v2/pages/common/secure-packaging-labeling.png',
        alt: 'Pickup & Safe Transport'
      }
    },
    {
      id: 3,
      title: 'Safe Storage & Return',
      description: 'Your items are stored safely until you request delivery to your dorm, apartment, or new location.',
      image: {
        src: '/images/v2/pages/common/fast-and-reliable-delivery.png',
        alt: 'Safe Storage & Return'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure College Storage Solutions',
  description:
    "Our affordable college storage solutions ensure maximum security with 24/7 surveillance, climate-controlled units, and restricted access. Your belongings are protected from theft, damage, and extreme temperatures, giving you peace of mind while you're away. Trust us to keep your items safe until you need them back.",
  image: {
    src: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/secure-college-storage-solutions.jpg',
    alt: 'Secure College Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Our College Storage Facilities',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description: 'We handle pickup, storage, and delivery for a completely stress-free experience.',
      image: {
        src: '/images/v2/pages/common/convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Security',
      description: 'Climate-controlled units, monitored facilities, and restricted access ensure safety.',
      image: {
        src: '/images/v2/pages/common/security.png',
        alt: 'Security'
      }
    },
    {
      id: 3,
      title: 'Affordability',
      description: 'Our affordable college storage solutions come with budget-friendly pricing and no hidden fees.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordability'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Benefits from Our College Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Studying Abroad',
          description: 'Store your belongings safely while you focus on your international experience.'
        },
        {
          id: 2,
          title: 'Summer & Semester Breaks',
          description: "Keep your dorm essentials safe while you're away."
        },
        {
          id: 3,
          title: 'Parents Looking for Secure Storage',
          description: 'An easy and reliable solution for your child’s belongings.'
        },
        {
          id: 4,
          title: 'Universities & Student Housing',
          description: 'Temporary storage for academic materials and dorm essentials.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/who-benefits-from-our-college-storage-solutions.jpg',
        alt: 'Who Benefits from Our College Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Residential Storage',
      description: 'Perfect for those moving, downsizing, or renovating. Secure and hassle-free.',
      image: {
        src: '/images/v2/pages/common/business-furniture-storage.png',
        alt: 'Residential Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Moving Storage',
      description: 'Temporary storage that makes transitions and relocations easier.',
      image: {
        src: '/images/v2/pages/common/moving-storage-solution.png',
        alt: 'Moving Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage',
      description: 'Flexible storage solutions for office supplies, documents, and inventory.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'College Storage',
      description: 'Affordable college storage solutions tailored for students, with easy pickup and return options.',
      image: {
        src: '/images/v2/pages/common/student-storage-options.png',
        alt: 'College Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Affordable College Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/why-choose-us-for-affordable-college-storage-solutions.jpg',
    alt: 'Why Choose Us for Affordable College Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Budget-Friendly Storage Plans',
      description:
        'Our affordable college storage offers clear pricing with no hidden fees and flexible payment options, making it easy for students to store their belongings stress-free.'
    },
    {
      id: 2,
      title: 'Flexible Storage Durations',
      description:
        'Whether you need storage for a summer break or an entire academic year, we offer both short-term and long-term options to match your schedule.'
    },
    {
      id: 3,
      title: 'Secure and Climate-Controlled Facilities',
      description:
        'Your items are kept in climate-controlled units with 24/7 monitoring. Our facilities protect your belongings from temperature changes, humidity, and unauthorized access.'
    },
    {
      id: 4,
      title: 'Nationwide Availability',
      description:
        'Our college storage services are available across multiple locations. No matter where your campus is, you can access secure and reliable storage.'
    },
    {
      id: 5,
      title: 'Convenient Pickup and Delivery',
      description:
        'We provide door-to-door pickup and delivery, ensuring a hassle-free experience. Students can focus on their studies while we take care of their storage needs.'
    },
    {
      id: 6,
      title: 'Easy Online Booking and Tracking',
      description:
        'Our user-friendly platform allows you to book, manage, and track your storage online. Get real-time updates for a smooth and worry-free experience.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Smart Storage Solutions for Students',
  description:
    'Affordable college storage solutions for students. Fast, secure, and affordable services for storing college items year-round.',
  image: {
    src: '/images/v2/pages/landing-pages/affordable-college-storage-solutions/smart-storage-solutions-for-students.png',
    alt: 'Smart Storage Solutions for Students'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Reserve Your Space' }
}

export const ourPartnersSectionContent = {
  title: 'Trusted Shipping Partners',
  description:
    'We collaborate with top shipping companies to provide secure and reliable services tailored to your needs.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx delivers dependable shipping solutions for your office equipment, ensuring timely and safe delivery.',
        "<strong>Disclaimer:</strong> This information was last updated in September 2024 and is for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, please visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL specializes in international shipping solutions tailored to your office equipment storage and retrieval needs.',
        "<strong>Disclaimer:</strong> This information was last updated in September 2024 and is for reference only. DHL does not guarantee the accuracy of the information provided. For more information, please visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers reliable transportation for your stored office equipment, ensuring a seamless experience.',
        "<strong>Disclaimer:</strong> This information was last updated in September 2024 and is for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more details, please visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
